import React,{Component} from "react";
import { withRouter } from 'react-router';
import Wrp from '../../../hoc/Wrp/Wrp';
import { connect } from 'react-redux';
import {callDELETE, callGET, callPOST} from '../../../Utils/ApiUtil';

import * as actions from '../../../store/actions';
import BreadCrumbs from "../../../Components/UI/BreadCrumbs";
import HeaderTabs from "../../../Components/UI/HeaderTabs";
import { getUserInfo,checkIsSystemUser } from "../../../Utils/UserFunctions";
import * as ShipConstants from '../../../Global/Constants';

class ImportContainer extends Component{

  state = {
    violations : [],
    status: '',
    importFormFields : {
          organization : {
            title : "Organization",
            field : "select",
            required : false,
            placeHolder : "",
            classname : 'form-control input-full',
            value : '',
            error: '',
            disabled:false,
            options : []
          },
          selectedFile: null
        }
  }

  componentWillMount = () => {
    this.organizationList();
  }

  organizationList = () => {
    callGET("organizations/organization-list/?orderBy=organization_name&direction=ASC&page=0&size=1000000")
    .then(response => {
      console.log(response);
      const responseData = response.data.data;
      if(response.data.code === ShipConstants.API_STATUS_SUCCESS) {
        const updateState = {...this.state};
        updateState.importFormFields['organization'].options = responseData.organization_list.content;
        this.setState(updateState);
      }
    }, (error) => {
        console.log(error);
    });
  }

  onChangeHandler = (event) => {
    const { name, value } = event.target;
    const updateState = { ...this.state };
    updateState.importFormFields[name].value= value; 
    console.log(updateState);
    this.setState(updateState);
  }
/*
  importHandler = () => {
    console.log('importHandler');
    console.log(this.state.importFormFields.organization.value);
    const orgId = this.state.importFormFields.organization.value;
    const header = { 'Content-Type': 'application/json' };
    callPOST("import-metadata/xml/all/"+orgId,{},header)
    .then(response => {
      console.log(response);
      const responseData = response.data;
    .catch(err => {
      console.log(err);
    })
  }*/

  handleImagePreview = (e) => {
        let image_as_base64 = URL.createObjectURL(e.target.files[0])
        let image_as_files = e.target.files[0];

        this.setState({
            image_preview: image_as_base64,
            image_file: image_as_files,
        })
  }

  // On file select (from the pop up) 
  onFileChange = event => { 
    const updateState = { ...this.state };
    updateState.importFormFields['selectedFile']= event.target.files[0]; 
    console.log(updateState);
    this.setState(updateState);
  }

  importHandler = () => {
    console.log('importHandler');
    console.log(this.state.importFormFields.organization.value);
    this.props.Loader();
    const orgId = this.state.importFormFields.organization.value;

    const fileInput = document.querySelector("#fileInput");
    const formData = new FormData();            
    formData.append("uploaded_zip_file", fileInput.files[0]);
    formData.append("type", "text/csv");
    let image_file = fileInput.files[0];
    const fileName = fileInput.value.split(/(\\|\/)/g).pop();
    let fileExtension = fileName.split('.').pop();
    console.log(fileName, fileExtension);
    const header = { 'Content-Type': 'application/json' };
    callPOST("import-metadata/xml/all/"+orgId,formData,{'Content-Type': 'multipart/form-data'})
    .then(response => {
      this.props.Loader();
      console.log(response);
      const responseData = response.data;
      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) { 
        this.props.succMessage(responseData.message);
        // this.downloadZip(responseData.data);
        if(responseData.violations) {
          this.setState({violations:responseData.violations,status:'SUCCESS'});
        }
      }else {
        if(responseData.violations) {
          this.setState({violations:responseData.violations,status:'FAIL'});
        }
        this.props.failMessage(responseData.message);
      }
    })
    .catch(err => {
      this.props.Loader();
      this.props.failMessage("Error occured");
      console.log(err);
    })
  }  

  render(){
    const params = this.props.match.params;

    const breadCrumbs =  {
        backHistory : [{
        href : "/settings",
        name:"Settings"
        }],
        pageTitle:"Import/Export",
        buttonList:[]
    }

    //HEADER TABS
    const headerTabs =  [{
      name:"Import",
      attributes:{
          "aria-selected":true,
          className:"nav-link active show"
      },
      href:"/import-export/import",
    },
    {
      name:"Export",
      attributes:{
          "aria-selected":false,
          className:"nav-link"
      },
      href:"/import-export/export",
    },{
      name:"ImportV2",
      attributes:{
          "aria-selected":false,
          className:"nav-link"
      },
      href:"/import-export/import-v2",
    },
    {
      name:"ExportV2",
      attributes:{
          "aria-selected":false,
          className:"nav-link"
      },
      href:"/import-export/export-v2",
    }]

    const {status,violations} = this.state;
    return (
      <Wrp>
        <BreadCrumbs breadCrumbsList={breadCrumbs} />
        <div className="viewport">
          <div className="view view--hor-scroll filters-v3 view-xl">
            
            <div className="view view--hor-scroll" >
               <HeaderTabs 
                attributes={{
                  className:"nav nav-pills navcrm-primary nav-pills-no-bd fixed-2",
                }} 
                headerTabsList={headerTabs} />

                <div className="row">
                  <div className="col-12">
                    <div className="mt-5"> 

                      <div className="card-body">
                        <div className="row">

                          <div className="col-6">
                            <div className="form-group form-inline">
                                <label htmlFor="inlineinput" className="col-md-3 col-form-label">Browse your file here <small className="pl-1"></small></label>

                                <div className="col-md-6 p-0">
                                    <input type="file" className="form-control-file" accept=".zip" id="fileInput" onChange={this.onFileChange} />
                                    <label className="error_1 error m-0"></label>
                                </div>
                            </div>
                          </div>

                          <div className="col-6">
                            <div className="form-group row">
                              <label htmlFor="inlineinput" className="col-lg-3 col-md-3 col-sm-4">
                              { checkIsSystemUser() ? 'Choose Organisation' : 'Import'}
                              </label> 

                              <div className="col-lg-9 col-md-9 col-sm-8">
                                 <div className="form-group">
                                 <div className="input-group mb-3">
                                  {
                                    checkIsSystemUser() ? 
                                      <select className="form-control" name="organization" onChange={e=>this.onChangeHandler(e)}>
                                        <option value=""></option>
                                        {
                                          this.state.importFormFields.organization.options.map((arr,i) => {
                                            return <option value={arr.id}>{arr.organization_name}</option>
                                          })
                                        }
                                      </select> 
                                    : null
                                  }  
                                    <div className="input-group-append">
                                        <span onClick={this.importHandler} className="input-group-text cursor-pointer" data-toggle="tooltip" data-placement="top" data-title="Import" data-trigger="hover"><i className="fas fa-file-import fa-lg"></i></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                             
                            </div> 
                          </div>
                          
                          {/*<div className="col-6"> 
                            <div className="form-group row">
                              <label htmlFor="inlineinput" className="col-lg-3 col-md-3 col-sm-4">Select Import Window</label> 

                              <div className="col-lg-9 col-md-9 col-sm-8">
                                 <div className="form-group">
                                  <div className="input-group mb-3">  
                                    <select className="form-control"></select>
                                    <div className="input-group-append">
                                      <span onClick={this.importHandler} className="input-group-text cursor-pointer" data-toggle="tooltip" data-placement="top" data-title="Import" data-trigger="hover"><i className="fas fa-file-import fa-lg"></i></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                             
                            </div> 
                          </div>*/}
                          { status !== '' && violations && Array.isArray(violations) && violations.length > 0 ?
                              <div className={status === 'SUCCESS' ? "col alert badge-warning fade show" : "col alert badge-danger fade show"}>
                                <strong>{status === 'SUCCESS' ? 'Warning!' : 'Error' }</strong>
                                <ul className="px-2 list-group list-group-bordered list" style={{"list-style-type":"disc"}}>
                                {
                                  violations.map((item,ind) => {
                                    return (
                                      <li key={ind}>
                                        {item.field_name} : {item.message}
                                      </li>
                                    )
                                  })
                                }
                                </ul>
                              </div>
                            : null }                           
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


            </div>   
          </div>
        </div>      
      </Wrp>
      
    );        
  }
}

const mapDispatchToProps = dispatch => {
  return {
    Loader : () => dispatch(actions.loader()),
    succMessage : (msg) => dispatch(actions.succMessage(msg)),
    failMessage : (msg) => dispatch(actions.failMessage(msg))    
  };
}
export default
  connect(
    null, 
    mapDispatchToProps
  )(withRouter(ImportContainer));